import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Paper
} from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

const DemoWebsite = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Header */}
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 3 }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h1" gutterBottom>
            ICON Accounting
          </Typography>
          <Typography variant="h6">
            Professional Accounting Services
          </Typography>
        </Container>
      </Box>

      {/* Hero Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h2" component="h2" gutterBottom>
              Expert Accounting Solutions
            </Typography>
            <Typography variant="h5" color="textSecondary" paragraph>
              Professional accounting services tailored to your business needs. 
              From bookkeeping to tax preparation, we've got you covered.
            </Typography>
            <Button
              variant="contained"
              size="large"
              startIcon={<ChatIcon />}
              sx={{ mt: 2 }}
            >
              Get Started Today
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h4" gutterBottom>
                Why Choose ICON Accounting?
              </Typography>
              <Typography variant="body1" paragraph>
                ✓ Professional expertise<br/>
                ✓ Personalized service<br/>
                ✓ Competitive pricing<br/>
                ✓ 24/7 support available
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Services Section */}
      <Box sx={{ bgcolor: 'white', py: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" textAlign="center" gutterBottom>
            Our Services
          </Typography>
          <Grid container spacing={4} sx={{ mt: 4 }}>
            <Grid item xs={12} md={4}>
              <Card>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    Bookkeeping
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Comprehensive bookkeeping services to keep your financial records organized and up-to-date.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    Tax Preparation
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Expert tax preparation services to ensure you maximize your returns and stay compliant.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    Financial Consulting
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Strategic financial consulting to help your business grow and achieve its goals.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Contact Section */}
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" textAlign="center" gutterBottom>
            Get In Touch
          </Typography>
          <Typography variant="h6" textAlign="center" paragraph>
            Ready to get started? Click the chat button in the bottom right corner 
            to speak with one of our experts today!
          </Typography>
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="body1">
              📞 Phone: +353 1 234 5678<br/>
              📧 Email: info@iconaccounting.ie<br/>
              📍 Address: Dublin, Ireland
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ bgcolor: 'grey.900', color: 'white', py: 4 }}>
        <Container maxWidth="lg">
          <Typography variant="body2" textAlign="center">
            © 2025 ICON Accounting. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default DemoWebsite;
